import { Component, Input } from '@angular/core';

@Component({
  selector: 'gcc-builder-item',
  templateUrl: './builder-item.component.html',
  styleUrls: ['./builder-item.component.scss'],
  standalone: false
})
export class BuilderItemComponent {
  @Input() public title = '';
}
